import React, { useState, useRef } from "react";
import SectionHeader from "../../../components/sectionHeader/sectionHeader";
import Tabs from "../../../components/tabs/tabs";
import Notification from "../../../components/notification/notification";
import ListaMuebles from "./pages/listaMuebles/listaMuebles";
import Borrador from "./pages/borrador/borrador";
import ListoParaDesplegar from "./pages/listoParaDesplegar/listoParaDesplegar";
import VersionesAnteriores from "./pages/versionesAnteriores/versionesAnteriores";

import "./gestionMuebles.scss";

export default function GestionMuebles() {
    const [activeTab, setActiveTab] = useState("borrador");
    const notificationRef = useRef(null);

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
    };

    return (
        <div className="gestion-muebles">
            <SectionHeader
                title="Gestión de muebles"
                subtitle="Crea y gestiona borradores, despliega versiones y consulta los cambios realizados anteriormente"
            />

            <Tabs
                tabs={[
                    { id: "listaMuebles", label: "Lista de muebles" },
                    { id: "borrador", label: "Borrador" },
                    { id: "listoParaDesplegar", label: "Listo para desplegar" },
                    {
                        id: "versionesAnteriores",
                        label: "Publicaciones Book",
                    },
                ]}
                activeTab={activeTab}
                onTabChange={handleTabChange}
            />

            <div className="gestion-muebles__content">
                {activeTab === "listaMuebles" && <ListaMuebles />}
                {activeTab === "borrador" && <Borrador />}
                {activeTab === "listoParaDesplegar" && (
                    <ListoParaDesplegar/>
                )}
                {activeTab === "versionesAnteriores" && <VersionesAnteriores />}
            </div>
            <Notification ref={notificationRef} />
        </div>
    );
}
